// @file Helpers that purely extend tldraw
import { useTldrawEditor } from '@@/vuecomposables/useTldrawEditor'
import type { TLShape } from 'tldraw'
import { renderPlaintextFromRichText } from 'tldraw'

function hasTextContent(shape: TLShape): boolean {
  const editor = useTldrawEditor().editor
  if (editor == null) return false
  return 'richText' in shape.props && renderPlaintextFromRichText(editor, shape.props.richText) !== ''
}

function getTextContent(shape: TLShape): string | null {
  const editor = useTldrawEditor().editor
  if (editor == null) return null
  if ('richText' in shape.props) return renderPlaintextFromRichText(editor, shape.props.richText)
  return null
}

export { getTextContent, hasTextContent }
